<template>
	<div>
		<div
			class="modal fade"
			id="vendorPopUp"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Vendor</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetAction()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div class="spinner-border" v-if="isLoading" style="margin:auto;display:block"/>
						<div v-else style = "padding:20px" class = "col-md-11" >
								<VendorData
									ref="vendor"
									:isDisableName = "isDisableName"
									:isDisableAlias = "isDisableAlias"
									:vendorList = "vendorList"
									:vendor = "vendor"
									:vendorAdded = "vendorAdded"
									@updateVendorObj = "updateVendorObj"
									:index = "index"
									:countryList = "countryList"
								/>
						</div>
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary"  @click = "saveVendor()">Save</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import Multiselect from "vue-multiselect";
import moment from "moment";
import datePicker from 'vue-bootstrap-datetimepicker';
import VendorData from './VendorData.vue';

export default {
	name: "VendorPopUp",
	components:{Multiselect, moment, datePicker, VendorData},
	props:[ "vendorList", "index"],
	data(){
		return{
			vendor:{
				go_vendor_cd:"",
				vendor_name:"",
				vc_alias:"",
				account_type:"",
				reporting_date:"",
				vendor:null,
				vendor_id:'',
				temp_vendor:'',
				country_currency:null,
			},
			isLoading:false,
			isEdit:false,
			submitted:false,
			vendorAdded:false,
			client_added:true,
			isDisableName:false,
			isDisableAlias:false,
			toggleData:false,
			countryList:[],
		}
	},
	watch:{
		
	},
	computed: {

	},
	mounted(){
	//	this.getVendorList();
		this.getCurrencyCountryList()
	},
	methods:{
		// getVendorList(){
		// 	const vm = this;
		// 	this.$store.dispatch("getAccountVendors").then(res=>{
		// 		vm.vendorList = res.filter(e=>e.vendor_name);
		// 	})
		//},
		// enterVendorName(e){
		// 	this.vendorAdded = false
		// // },
		// selectNewVendor(data){
		// 	this.vendorAdded = false
		// 	 this.isLoading = true;
		// 		 let obj = {}
		// 		 if(data.id){
		// 			 obj.go_vendor_cd = data.id;
		// 			 obj.vendor_name = data.vendor_name;
		// 			 obj.vc_alias = data.vc_alias;
		// 			 obj.account_type = data.account_type;
		// 			 obj.reporting_date = data.reporting_startdate ? moment(data.reporting_startdate).utc().format("YYYY-MM-DD"): '';
		// 			 this.vendor = obj;
		// 		 }
		//
		// 	 this.isLoading = false;
		// },
		getCurrencyCountryList(){
			let vm = this;
			this.$store.dispatch("accounts/getCurrencyCountryList").then((res) => {
				vm.countryList = res;
				let data = vm.countryList.find((e) => e.country_code == 'US')
				if(data && data.country_code)
				{
					let index = vm.countryList.indexOf(data)
					vm.countryList.splice(index, 1)
					vm.countryList.unshift(data)
				}

			})
		},
		resetAction(){
			this.$refs['vendor'].isDataPresent = false;
			this.$emit("updateCancelVendorList")
			this.$refs['vendor'].validateData(false);
			this.resetData()
		},
		saveVendor(){
				this.submitted = true
				if(this.isValidate()){
					let vm = this;
				//	this.vendor.go_client_id = this.client_id;
					if(this.vendor.id){
						this.vendor.go_vendor_cd = this.vendor.id
					}
					this.vendor.vendor_name = this.vendor.vendor.vendor_name
					if(this.vendor && this.vendor.country_currency){
						this.vendor.country_code = this.vendor.country_currency.country_code
						this.vendor.currency_code = this.vendor.country_currency.currency_code
					}
					// delete vendor['country_currency']
					this.isLoading= true
					this.$store.dispatch("accounts/saveVendorInVendorMaster", this.vendor).then((res) => {
						vm.isLoading= false
						if(res){
						vm.$nextTick (() => {
							if(res == 'Vendor already present cannot be added'){
								vm.$refs["vendor"].isDataPresent= true
								vm.vendorAdded = true
							}
							else{
								vm.$emit("updateVendorList", res, vm.index)
							}
							vm.resetData()
						});
						}
					})
				}

		},
		isValidate(){
			// let isAlreadyAdded = this.vendorList.find((e) => (e.vc_alias.toLowerCase().trim() == this.vendor.vc_alias.toLowerCase().trim()))

			let checkDuplicate = this.$refs['vendor'].isDataPresent || this.$refs['vendor'].isVendorNamePresent;

			// if(isAlreadyAdded){
			// 	this.vendorAdded = true
			// }

			// if(!this.client_id){
			// 	this.client_added = false
			// }

			if((this.vendor && this.vendor.vendor && !this.vendor.vendor.vendor_name) || this.vendorAdded || checkDuplicate || (!this.vendor || !this.vendor.country_currency || !this.vendor.country_currency.country_code)){
				this.$refs['vendor'].validateData(true);
				return false
			}
			else{
				this.$refs['vendor'].validateData(false);
				return true
			}
		},
		resetData(){
			this.$refs['vendor'].validateData(false);
			this.isLoading = false;
			this.isEdit = false;
			this.submitted = false;
			this.vendorAdded = false;
			this.client_added = true;
			this.isDisableName = false;
			this.isDisableAlias = false;
			this.toggleData = false
			this.vendor = {
				go_vendor_cd:"",
				vendor_name:"",
				vc_alias:"",
				account_type:"",
				reporting_date:"",
				vendor:{},
				vendor_id:'',
				country_currency:null,
			}
			// this.countryList = []
		},
		updateVendorObj(data){
			this.vendor = data;
		}
	}
}

</script>
